/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Typography, Tabs, Tab, Box, Button, Stack, Dialog, DialogContent } from '@mui/material';
import axios from 'axios';
import useRequestIdGenerater from 'customhooks';
import React, { useEffect, useState } from 'react';
import useTimeStamp from 'reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp';
import SubCard from 'ui-component/cards/SubCard';
import FullPostDetailsCard from 'views/application/users/social-profile/FullPostDetailsCard';
import PostDetails from 'views/application/users/social-profile/PostDetails';

const ActivityCard = () => {


    const RequestId = useRequestIdGenerater();
    const { rendomRequestId, generateTimeStamp } = useTimeStamp();

    const [tabIndex, setTabIndex] = useState(0);
    const [comments, setComments] = useState([]);
    const [likedPosts, setLikedPosts] = useState([]);
    const [likedPage, setLikedPage] = useState(0);
    const [commentsPage, setCommentsPage] = useState(0);
    const [totalLikedPages, setTotalLikedPages] = useState(1);
    const [totalCommentPages, setTotalCommentPages] = useState(1);


    const [PostDetailsResponse, setPostDetailsResponse] = useState({})
    const [openPostDetails, setOpenPostDetails] = useState(false)

    const [alumniDetails, setAlumniDetails] = useState([]);
    const Role = localStorage.getItem("role");

    const [isLoading, setIsLoading] = useState(false);

    const PAGE_SIZE = 2;

    const fetchData = async () => {
        if (tabIndex === 0) {
            await getMyLikedPosts(likedPage);
        } else {
            await getMyCommentedPosts(commentsPage);
        }
    };

    const getPostByPostId = async (postId) => {
        if (!postId) return;

        setIsLoading(true);
        try {
            const response = await axios.get(`/v1/posts/details?postId=${postId}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
                    ),
                },
            });
            setPostDetailsResponse(response?.data?.data);
            setOpenPostDetails(true);
        } catch (error) {
            console.error("Failed to fetch post details:", error);
        } finally {
            setIsLoading(false);
            generateTimeStamp();
        }
    };


    const getMyCommentedPosts = async (pageNumber) => {
        try {
            const response = await axios.get(
                `/v1/posts/my/comment-list?pageSize=${PAGE_SIZE}&pageNumber=${pageNumber}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
                        ),
                    },
                }
            );
            const { content, totalPages } = response?.data?.data || {};
            setComments(content || []);
            setTotalCommentPages(totalPages || 1);
            generateTimeStamp();
        } catch (error) {
            generateTimeStamp();
            console.error("Failed to fetch comments:", error);
        }
    };

    const getMyLikedPosts = async (pageNumber) => {
        try {
            const response = await axios.get(
                `/v1/posts/my/post-like-list?pageSize=${PAGE_SIZE}&pageNumber=${pageNumber}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
                        ),
                    },
                }
            );
            const { content, totalPages } = response?.data?.data || {};
            setLikedPosts(content || []);
            setTotalLikedPages(totalPages || 1);
            generateTimeStamp();
        } catch (error) {
            generateTimeStamp();
            console.error("Failed to fetch liked posts:", error);
        }
    };

    const getAlumniDetails = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `/v1/alumni/info?userId=${localStorage.getItem('userId')}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem(
                            "serviceToken"
                        )}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
                        ),
                    },
                }
            );
            setAlumniDetails(response?.data?.data);
            localStorage.setItem("alumniBatchId", response?.data?.data?.batch?.id ?? "");
            setIsLoading(false);
            generateTimeStamp();
        } catch (error) {
            setIsLoading(false);
            generateTimeStamp();
            console.error("Failed to fetch data:", error);
        }
    };

    useEffect(() => {
        generateTimeStamp();
        fetchData();
    }, [tabIndex, likedPage, commentsPage]);

    const handleTabChange = (_, newValue) => {
        setTabIndex(newValue);
        if (newValue === 0) {
            setLikedPage(0);
        } else {
            setCommentsPage(0);
        }
    };

    const handlePrev = () => {
        if (tabIndex === 0) {
            setLikedPage((prev) => Math.max(prev - 1, 0));
        } else {
            setCommentsPage((prev) => Math.max(prev - 1, 0));
        }
    };

    const handleNext = () => {
        if (tabIndex === 0) {
            setLikedPage((prev) => Math.min(prev + 1, totalLikedPages - 1));
        } else {
            setCommentsPage((prev) => Math.min(prev + 1, totalCommentPages - 1));
        }
    };

    const handleUpdatePostLikes = (updatedPost) => {
        const updatedPosts = likedPosts?.map((post) => {
            if (post.id === updatedPost.id) {
                return updatedPost;
            } else {
                return post;
            }
        });
        setLikedPosts(updatedPosts);
    };
    const handleUpdateCommentedPost = (updatedPost) => {
        setPostDetailsResponse(updatedPost);
    };


    const handleCommentClick = (postId) => () => {
        if (postId) {
            getPostByPostId(postId);
        } else {
            console.warn("Empty postId clicked");
        }
    };

    useEffect(() => {
        getAlumniDetails();
        generateTimeStamp();
    }, []);

    return (
        <>
            <SubCard
                sx={{
                    mt: 1,
                    p: 1,
                    overflow: "auto",
                    "&::-webkit-scrollbar": {
                        width: "0.5em",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#ffffff",
                    },
                }}
                title={
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontWeight: 500 }}>
                            <span style={{ color: "#245081", fontSize: "18px" }}>
                                Activity Details
                            </span>
                        </Typography>
                    </div>
                }
            >
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label="Reactions" />
                    <Tab label="Comments" />
                </Tabs>

                <Box sx={{ mt: 2 }}>
                    {tabIndex === 0 && (
                        <Grid container direction="column" spacing={1}>
                            {likedPosts.length > 0 ? (
                                likedPosts.map((post, index) => (

                                    <Grid key={post.id} item xs={12}>
                                        <PostDetails
                                            isLoading={isLoading}
                                            alumniDetails={alumniDetails}
                                            post={post}
                                            setPosts={handleUpdatePostLikes}
                                        />
                                    </Grid>
                                ))
                            ) : (
                                <Typography>No liked posts found.</Typography>
                            )}
                            <PaginationControls
                                page={likedPage}
                                totalPages={totalLikedPages}
                                onNext={handleNext}
                                onPrev={handlePrev}
                            />
                        </Grid>
                    )}

                    {tabIndex === 1 && (
                        <Grid container direction="column" spacing={1}>
                            {comments?.length > 0 ? (
                                comments.map((comment, index) => (
                                    <Grid item key={comment.id || index}>
                                        <Box
                                            onClick={() => comment?.postsId && getPostByPostId(comment.postsId)}
                                            sx={{
                                                p: 2,
                                                border: '1px solid #e0e0e0',
                                                borderRadius: 2,
                                                cursor: 'pointer',
                                                transition: 'background 0.2s',
                                                '&:hover': {
                                                    backgroundColor: '#f5f5f5'
                                                }
                                            }}
                                        >
                                            <Typography variant="body1" sx={{ fontWeight: 500, color: '#333' }}>
                                                {comment.comment || 'No comment'}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#777' }}>
                                                {comment.postTitle || 'Click to view post'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))
                            ) : (
                                <Typography>No comments found.</Typography>
                            )}

                            <PaginationControls
                                page={commentsPage}
                                totalPages={totalCommentPages}
                                onNext={handleNext}
                                onPrev={handlePrev}
                            />
                        </Grid>
                    )}
                </Box>
            </SubCard>

            <Dialog
                open={openPostDetails}
                onClose={() => setOpenPostDetails(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        width: '800px',
                        maxWidth: '90vw',
                    }
                }}
            >
                <DialogContent>
                    <FullPostDetailsCard
                        isLoading={isLoading}
                        alumniDetails={alumniDetails}
                        post={PostDetailsResponse}
                        setPosts={handleUpdateCommentedPost}
                    />
                </DialogContent>
            </Dialog>

        </>
    );
};


const PaginationControls = ({ page, totalPages, onPrev, onNext }) => (
    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
        <Button variant="outlined" size="small" disabled={page === 0} onClick={onPrev}>
            Previous
        </Button>
        <Typography variant="body2">
            Page {page + 1} of {totalPages}
        </Typography>
        <Button variant="outlined" size="small" disabled={page + 1 >= totalPages} onClick={onNext}>
            Next
        </Button>
    </Stack>
);

export default ActivityCard;
